module.exports = __webpack_public_path__ + "assets/images/XCD1.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/XCD1.png
// module id = 1474
// module chunks = 1